import { omit } from 'lodash';
import { Moment } from 'moment';
import qs from 'qs';
import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SearchControls } from 'src/components/search-controls';
import { calculateStatusCounts } from 'src/components/status-filter/calculateStatusCounts';
import history from 'src/config/browser-history';
import { IOrder, Status } from 'src/graphql/types';
import styled from 'styled-components';
import { DateRangePillSearchForm } from '../../components/date-range-form/date-range-pill-search-form';
import { StatusFilter } from '../../components/status-filter';
import { VesselFilter } from '../../components/status-filter/vessel-filter';
import {
  defaultEndDate,
  defaultStartDate,
  URL_DATE_FORMAT,
} from '../../constants/dates';
import { DownloadCSVdata } from './download-orders';
import { ordersRoute } from './route';

const DownloadCSVLink = styled.button`
  position: absolute;
  right: 40px;
  background: none;
  border: 0;
  text-decoration: underline;
  color: blue;
  cursor: pointer;
`;

export const OrdersSearchControls: FC<{
  soldToId: string;
  shipToId?: string;
  startDate?: Moment;
  endDate?: Moment;
  statuses: Status[];
  orders: IOrder[];
  showDatePill: boolean;
  vesseles: string[];
}> = ({
  soldToId,
  shipToId,
  startDate = defaultStartDate,
  endDate = defaultEndDate,
  statuses,
  orders,
  showDatePill,
  vesseles,
}) => {
  const [downloadData, setDownloadData] = useState(false);
  const location = useLocation();
  const originalParams = omit(
    qs.parse(location.search, { ignoreQueryPrefix: true }),
    'uid'
  );

  const handleDownload = () => {
    setDownloadData(true);
  };

  const applyStatusFilter = (selectedStatuses: Status[]) => {
    history.push(
      ordersRoute(soldToId, {
        ...originalParams,
        status: selectedStatuses.join(',') || undefined,
      })
    );
  };

  const applyVesselFilter = (selectedStatuses: string[]) => {
    history.push(
      ordersRoute(soldToId, {
        ...originalParams,
        vessel: selectedStatuses.join(',') || undefined,
      })
    );
  };

  const ordersFilteredByVessel = orders
    .filter(order => order?.partnerInfo !== null)
    .map(p => p.partnerInfo?.vesselName);

  const ordersFilteredWithoutByVessel = orders
    .filter(order => order?.partnerInfo === null)
    .map(p => p.partnerInfo?.vesselName);

  for (const count of ordersFilteredWithoutByVessel) {
    ordersFilteredByVessel.push('Empty');
  }
  const uniqueVessels = ordersFilteredByVessel.filter((c, index) => {
    return ordersFilteredByVessel.indexOf(c) === index;
  });

  return (
    <SearchControls>
      {showDatePill && (
        <DateRangePillSearchForm
          soldToId={soldToId}
          shipToId={shipToId}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      <StatusFilter
        statuses={statuses}
        statusCounts={calculateStatusCounts(orders)}
        applyStatusFilter={applyStatusFilter}
      />
      {uniqueVessels.length > 1 && (
        <VesselFilter
          vesseles={ordersFilteredByVessel}
          selectedVessel={vesseles}
          applyStatusFilter={applyVesselFilter}
        />
      )}

      {orders.length > 0 && !downloadData && (
        <DownloadCSVLink
          onClick={handleDownload}
          style={{
            position: 'absolute',
            right: '40px',
            background: 'none',
            border: '0',
            textDecoration: 'underline',
            color: 'blue',
            cursor: 'pointer',
          }}
        >
          Download CSV
        </DownloadCSVLink>
      )}
      {downloadData && (
        <DownloadCSVdata
          soldToId={soldToId}
          shipToId={shipToId}
          startDate={startDate.format(URL_DATE_FORMAT)}
          endDate={endDate.format(URL_DATE_FORMAT)}
        />
      )}
    </SearchControls>
  );
};
